module.exports = __webpack_public_path__ + "static/media/Samantha_M (1).e05d2c13.webp";